<div class="top-section">
    <h3>
        API List
    </h3>
</div>

<section class="rate-request rate-request-sec">
    <div class="middle-section">
        <div class="container">
            <div class="rate-request-form">

                <div class="rate-request-form-inner">
                    <div class="select-sec">
                        <div class="select-section-relative">
                            <p-calendar [(ngModel)]="selectedDate" (onSelect)="toDateChange()" [readonlyInput]="true"
                                showIcon="true" showButtonBar="true" placeholder="Date" [monthNavigator]="true"
                                [yearNavigator]="true" yearRange="{{rageYears}}" icon="pi pi-calendar" iconPos="left"
                                dateFormat="dd-MM-yy"></p-calendar>
                        </div>
                    </div>
                    <div class="request-btn">
                        <input type="text" class="form-control" pInputText size="50" placeholder="Search"
                            (change)="filterSearch($event.target.value)">
                        <div class="btn-search"><button class="btn  btn-go my-2 my-sm-0" type="button"
                                (click)="getAPIList()"><img src="../../../assets/images/Group 103.svg"></button></div>
                    </div>
                </div>
                <div class="table-responsive rate-request-tbl">

                    <p-table [value]="APIData">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>API Name</th>
                                <th>Total Requests on a Day </th>
                                <th>CSV API Requests</th>
                                <th>Tracking API Requests</th>
                                <th>API Requests Available</th>
                                <th>Date</th>
                                <th>CSV file</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-api>
                            <tr>
                                <td>{{ api.apiName }}</td>
                                <td>{{ api.totalUsedRequest }}</td>
                                <td>{{ api.csvRequest }}</td>
                                <td>{{ api.trackingRequest }}</td>
                                <td>{{ api.leftRequests }}</td>
                                <td>{{ api.createdDate }}</td>
                                <td>
                                    <a href="javascript:void(0)" tooltipPosition="top" pTooltip="Export CSV file"
                                        (click)="exportToCSV(api.createdDate)">
                                        <img src="../../../../assets/images/CSVIcon.png" />
                                    </a>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <p-paginator *ngIf="totalcount > 0" [rows]="pageSize" [rowsPerPageOptions]="[5,10,20]"
                    [totalRecords]="totalcount" (onPageChange)="paginate($event)"></p-paginator>
                <div *ngIf="totalcount == 0">
                    <span>No records found</span>
                </div>
            </div>
        </div>
    </div>
</section>